import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PageHero, Reveal, Stagger, StaggerItem, Overline } from "@/components/primitives";
import { ArrowRight, Star } from "lucide-react";
import { ARTICLES } from "@/data/insights";

export default function Insights() {
  const pillar = ARTICLES.find((a) => a.pillar);
  const rest = ARTICLES.filter((a) => !a.pillar);
  return (
    <>
      <PageHero
        overline="Insights"
        title="India's ethanol economy, explained."
        subtitle="The numbers, the roadmap and what comes after E20 — written plainly, updated as policy moves."
      />

      <section className="bg-parchment py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          {/* Pillar */}
          {pillar && (
            <Reveal>
              <Link to={`/insights/${pillar.slug}`} className="group grid overflow-hidden rounded-3xl border border-border bg-white shadow-sm transition-all hover:shadow-2xl lg:grid-cols-2">
                <div className="relative h-64 overflow-hidden lg:h-auto">
                  <img src={pillar.image} alt={pillar.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <span className="absolute left-5 top-5 inline-flex items-center gap-1.5 rounded-full bg-ethanolOrange px-3 py-1 text-xs font-bold uppercase tracking-wide text-navy"><Star className="h-3 w-3" /> Pillar guide</span>
                </div>
                <div className="flex flex-col justify-center p-8 md:p-12">
                  <Overline className="mb-3">Start here</Overline>
                  <h2 className="font-display text-2xl font-semibold tracking-tight text-navy md:text-3xl">{pillar.title}</h2>
                  <p className="mt-4 text-navy/70">{pillar.dek}</p>
                  <span className="mt-6 inline-flex items-center gap-2 font-semibold text-emeraldDeep transition-all group-hover:gap-3.5">Read the guide <ArrowRight className="h-4 w-4" /></span>
                </div>
              </Link>
            </Reveal>
          )}

          {/* Grid */}
          <Stagger className="mt-12 grid gap-7 md:grid-cols-2 lg:grid-cols-3">
            {rest.map((a) => (
              <StaggerItem key={a.slug}>
                <Link to={`/insights/${a.slug}`} className="group flex h-full flex-col overflow-hidden rounded-3xl border border-border bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-xl">
                  <div className="relative h-44 overflow-hidden">
                    <img src={a.image} alt={a.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <p className="text-xs font-medium text-navy/40">{a.updated} · {a.readTime}</p>
                    <h3 className="mt-2 font-display text-lg font-bold leading-snug text-navy">{a.title}</h3>
                    <p className="mt-2 flex-1 text-sm text-navy/60">{a.dek}</p>
                    <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-emeraldDeep transition-all group-hover:gap-3">Read <ArrowRight className="h-4 w-4" /></span>
                  </div>
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </>
  );
}
